import { render, staticRenderFns } from "./menuDetail.vue?vue&type=template&id=181eae33&scoped=true"
import script from "./menuDetail.vue?vue&type=script&lang=js"
export * from "./menuDetail.vue?vue&type=script&lang=js"
import style0 from "./menuDetail.vue?vue&type=style&index=0&id=181eae33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181eae33",
  null
  
)

export default component.exports